export default __webpack_public_path__ + "static/media/scan.22043de9.svg";